import { action } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { inc } from '@nullvoxpopuli/ember-composable-helpers';
import type StatsigService from 'garaje/services/statsig';

export default class PageTemplate extends Component<{
  Args: {
    headerTitle: string;
    headerInfo: string;
    currentStep: number;
    totalStepCount: number;
    demoName: string;
    isUserLoggedIn: boolean;
    isDemoInstance: boolean;
  };
  Blocks: {
    default: [];
  };
}> {
  @service declare statsig: StatsigService;

  @action sendPageViewEvent(): void {
    if (this.args.isUserLoggedIn && !this.args.isDemoInstance) {
      this.statsig.logEvent(`kiosk-demo-${this.args.demoName}-page-viewed`, (this.args.currentStep + 1).toString());
    }
  }

  <template>
    <div {{didInsert this.sendPageViewEvent}} class="flex flex-col p-8">
      {{! Step count }}
      <div class="flex flex-row text-carbon-40 mb-[13px] text-sm">
        {{inc @currentStep}}
        of
        {{@totalStepCount}}
      </div>
      {{! Header container }}
      <div class="flex flex-col gap-2">
        <div class="text-carbon-70 text-lg font-bold">
          {{@headerTitle}}
        </div>
        <div class="text-carbon-70 text-md mb-8">
          {{@headerInfo}}
        </div>
      </div>
      {{! Action list container }}
      <div class="flex flex-col">
        {{yield}}
      </div>
    </div>
  </template>
}
